import { createRouter, createWebHistory } from 'vue-router'
import UserGuideExplanation from './views/UserGuide/Explanation'
import UserGuidePrice from './views/UserGuide/Price'
import UserGuideQuestionAndAnswer from './views/UserGuide/QuestionAndAnswer'
import UserGuideTerms from './views/UserGuide/Terms'
import V1History from './views/v1/History'
import V1Charge from './views/v1/Charge'
import V1AppTop from './views/v1/AppTop'
import V1Settlement from './views/v1/Settlement.vue'
import V1CardEntryConfirm from './views/v1/CardEntryConfirm'
import V1CardEntry from './views/v1/CardEntry'
import V1InitialAgreement from './views/v1/InitialAgreement'

const routes = [
  {
    path: '/carwash/userguide/explanation',
    name: 'UserGuideExplanation',
    component: UserGuideExplanation
  },
  {
    path: '/carwash/userguide/price',
    name: 'UserGuidePrice',
    component: UserGuidePrice
  },
  {
    path: '/carwash/userguide/qa',
    name: 'UserGuideQuestionAndAnswer',
    component: UserGuideQuestionAndAnswer
  },
  {
    path: '/carwash/userguide/terms',
    name: 'UserGuideTerms',
    component: UserGuideTerms
  },
  {
    path: '/carwash/v1/history',
    name: 'V1History',
    component: V1History
  },
  {
    path: '/carwash/v1/initialAgreement',
    name: 'V1InitialAgreement',
    component: V1InitialAgreement
  },
  {
    path: '/carwash/v1/charge',
    name: 'V1Charge',
    component: V1Charge
  },
  {
    path: '/carwash/v1/moveAppTop',
    name: 'V1AppTop',
    component: V1AppTop
  },
  {
    path: '/carwash/v1/settlement',
    name: 'V1Settlement',
    component: V1Settlement
  },
  {
    path: '/carwash/v1/gmo/cardEntryConfirm',
    name: 'V1CardEntryConfirm',
    component: V1CardEntryConfirm
  },
  {
    path: '/carwash/v1/gmo/cardEntry',
    name: 'V1CardEntry',
    component: V1CardEntry
  }
]
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
